import React from "react";
import { ObjectiveFromListing } from "../../../interfaces/training-plan/ObjectiveFromListing";
import { CustomChip } from "../../global/chips/CustomChip";
import { Grid } from "@mui/material";

type BlogChipsProps = {
  objectives: ObjectiveFromListing[];
};

export const BlogChips = ({ objectives }: BlogChipsProps) => {
  if (objectives) {
    return (
      <>
        {objectives.map((objective: ObjectiveFromListing, i) => {
          if (i < 2) {
            return (
              <Grid item xs={5} key={objective.id}>
                <CustomChip label={objective.title} />
              </Grid>
            );
          }
        })}
      </>
    );
  }
};
